"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.presetColors = exports.validPillColorPresets = void 0;
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
exports.validPillColorPresets = [
    'turquoise90',
    'brandPurple',
    'neutral90',
    'red',
    'orange',
    'yellow',
    'green',
    'neutral',
    'blue',
    'teal',
    'purple',
    'disabled',
];
var presetColors = function (selectedTheme) { return ({
    turquoise90: {
        color: 'turquoise90',
        borderColor: 'turquoise90',
        textColor: 'white',
    },
    brandPurple: {
        color: 'brandPurple',
        borderColor: 'brandPurple',
        textColor: 'white',
    },
    neutral90: {
        color: 'neutral90',
        borderColor: 'neutral90',
        textColor: 'white',
    },
    red: {
        color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'red70', dark: 'darkTheme.dimRed' }),
        borderColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'red70', dark: 'darkTheme.red100' }),
        textColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'white', dark: 'darkTheme.red100' }),
    },
    orange: {
        color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'orange70', dark: 'darkTheme.dimOrange' }),
        borderColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'orange70', dark: 'darkTheme.orange' }),
        textColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'white', dark: 'darkTheme.orange' }),
    },
    yellow: {
        color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'yellow50', dark: 'darkTheme.dimYellow' }),
        borderColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'yellow50', dark: 'darkTheme.yellow' }),
        textColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'black', dark: 'darkTheme.yellow' }),
    },
    green: {
        color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'green70', dark: 'darkTheme.dimGreen' }),
        borderColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'green70', dark: 'darkTheme.green100' }),
        textColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'white', dark: 'darkTheme.green100' }),
    },
    blue: {
        color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'blue70', dark: 'darkTheme.dimBlue' }),
        borderColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'blue70', dark: 'darkTheme.blue100' }),
        textColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'white', dark: 'darkTheme.blue100' }),
    },
    teal: {
        color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'teal70', dark: 'darkTheme.dimTeal' }),
        borderColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'teal70', dark: 'darkTheme.teal100' }),
        textColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'white', dark: 'darkTheme.teal100' }),
    },
    purple: {
        color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'purple70', dark: 'darkTheme.dimPurple' }),
        borderColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'purple70', dark: 'darkTheme.purple100' }),
        textColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'white', dark: 'darkTheme.purple100' }),
    },
    neutral: {
        color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'neutral70', dark: 'darkTheme.dimWhite' }),
        borderColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'neutral70', dark: 'darkTheme.white' }),
        textColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'white', dark: 'darkTheme.white' }),
    },
    disabled: {
        color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'neutral20', dark: 'darkTheme.dimWhite' }),
        borderColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'neutral20', dark: 'neutral70' }),
        textColor: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'neutral70', dark: 'neutral60' }),
    },
}); };
exports.presetColors = presetColors;
